import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { isConfirmedDoc } from '../../../lib/packingListWire';

/**
 * 문서 카드의 X로 문서를 지우기 전 경고. 확정본이면 그 PL의 아이템과 컨테이너 배분까지 함께 사라진다고 알린다.
 * doc이 null이면 닫혀 있다. 지우는 요청이 진행 중(busy)이면 닫거나 다시 누를 수 없다.
 */
export default function DeleteDocumentDialog({ doc, busy, onCancel, onConfirm }) {
    const confirmed = isConfirmedDoc(doc);
    const name = doc?.invoice_no || (confirmed ? 'This packing list' : 'This draft');
    return (
        <Dialog open={Boolean(doc)} onClose={() => !busy && onCancel()} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ fontSize: 14, color: '#003a52' }}>{confirmed ? 'Delete this confirmed packing list?' : 'Delete this draft?'}</DialogTitle>
            <DialogContent>
                <Typography sx={{ fontSize: 12 }}>
                    {confirmed ? (
                        <>
                            <b>{name}</b> will be removed with its items and container allocations. Shippers will no longer see it. This cannot be undone.
                        </>
                    ) : (
                        <>
                            <b>{name}</b> will be removed and its saved edits are lost. This cannot be undone.
                        </>
                    )}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button size="small" onClick={onCancel} disabled={busy} sx={{ fontSize: 12 }}>Cancel</Button>
                <Button size="small" variant="contained" color="error" onClick={onConfirm} disabled={busy} sx={{ fontSize: 12 }}>Delete</Button>
            </DialogActions>
        </Dialog>
    );
}
